
import WebFont from 'webfontloader'

const options = {"events":false,"google":{"families":["Inter:400,500,600,700:cyrillic&display=swap"]},"timeout":5000}

WebFont.load(options)
